import React from "react";

const ReloadButton = ({ onClick, loading = false, disabled = false, title = "Yenilə", size = 28 }) => (
  <button
    onClick={onClick}
    disabled={loading || disabled}
    title={title}
    style={{
      width: size,
      height: size,
      border: "none",
      borderRadius: 6,
      background: "var(--color-primary)",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: loading || disabled ? "not-allowed" : "pointer",
      opacity: loading ? 0.8 : 1,
      transition: "opacity 0.2s, background 0.2s",
      flexShrink: 0,
    }}
  >
    <i className={`bi bi-arrow-clockwise${loading ? " spin" : ""}`} />
  </button>
);

export default ReloadButton;
